export default __webpack_public_path__ + "ff036ffd7b0a454b1dfc1aaeb7a20910.svg";